import { Route } from "react-router-dom";
import { Article1 } from "./Article1";
import { Article2 } from "./Article2";
import { Article3 } from "./Article3";
import { Article4 } from "./Article4";
import { Article5 } from "./Article5";
import { Article6 } from "./Article6";
import { seoArticles } from "../../seo/articleCatalog";

const articleComponents = {
  "coach-sportif-domicile-ile-de-france-avantages-benefices": Article1,
  "coaching-sportif-domicile-avance-immediate-payer-moitie-prix": Article2,
  "coaching-sportif-personnalise-domicile-femmes-actives": Article3,
  "tarifs-coach-sportif-domicile-ile-de-france": Article4,
  "perte-poids-coach-sportif-domicile-ile-de-france": Article5,
  "coaching-bien-etre-remise-en-forme-domicile-seniors-ile-de-france": Article6,
};

export const ArticleRoutes: React.FC = () => (
  <>
    {seoArticles.map(article => {
      const component = articleComponents[article.id as keyof typeof articleComponents];
      return <Route key={article.path} path={article.path} component={component} />;
    })}
  </>
);
